import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout.jsx";
import "./Client.css";
import { clientService } from "../services/apiService.jsx";
import { useAuth } from "../context/AuthContext.jsx";

// Client Details Modal
const ClientDetailsModal = ({ client, onClose }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return isNaN(d) ? '-' : d.toLocaleDateString();
  };

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header bg-light border-bottom">
            <h5 className="modal-title">Client Details</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="card">
              <div className="card-body">
                {/* Client Name Section */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Client Name:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.customer_name || '-'}</p>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Website:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>
                      {client.web_address ? (
                        <a
                          href={client.web_address.startsWith("http") ? client.web_address : `https://${client.web_address}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {client.web_address}
                        </a>
                      ) : (
                        '-'
                      )}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Location:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.location || '-'}</p>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Address:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.address || '-'}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Billing Address:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.billing_address || '-'}</p>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Contact Person:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.contact_person || '-'}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Contact Position:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.cp_position || '-'}</p>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Contact Number:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.cp_contact_num || '-'}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Contact Email:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{client.cp_mail || '-'}</p>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                      <strong>Onboard Date:</strong>
                    </p>
                    <p style={{ fontSize: '1rem' }}>{formatDate(client.customer_joiningDate)}</p>
                  </div>
                </div>

                {client.inactive_reason && (
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <p className="mb-1" style={{ fontSize: '0.875rem', color: '#666' }}>
                        <strong>Inactive Reason:</strong>
                      </p>
                      <p style={{ fontSize: '1rem' }}>{client.inactive_reason}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Client = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = () => {
    clientService
      .getAllClients()
      .then((data) => {
        setClients(Array.isArray(data.data) ? data.data : []);
      })
      .catch((error) => {
        console.error("Error fetching clients:", error);
        setClients([]);
      });
  };

  const handleEdit = (clientId) => {
    navigate(`/update-client/${clientId}`);
  };

  const handleView = (client) => {
    setSelectedClient(client);
  };

  const handleCloseModal = () => {
    setSelectedClient(null);
  };

  const handleDelete = async (clientId, clientName) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete client ${clientName}? This action cannot be undone.`
    );
    if (!confirmDelete) return;

    setIsDeleting(true);

    try {
      await clientService.deleteClient(clientId);
      fetchClients();
      alert("Client deleted successfully!");
    } catch (error) {
      console.error("Error deleting client:", error);
      let errorMsg = "Failed to delete client";
      if (error.response) {
        if (error.response.status === 401) errorMsg = "You are not authorized. Please login again.";
        else if (error.response.status === 403) errorMsg = "You don't have permission to delete clients.";
        else if (error.response.status === 404) errorMsg = "Client not found.";
        else errorMsg = error.response.data?.message || errorMsg;
      } else if (error.request) {
        errorMsg = "No response from server. Please check your internet connection.";
      }
      alert(errorMsg);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleAdd = () => {
    navigate("/createclient");
  };

  const canCreateClient = [
    "admin",
    "manager",
    "project manager",
    "project_manager",
    "projectmanager",
    "employee",
    "hod",
    "team lead",
    "teamlead",
    "tl",
  ].includes(String(user?.role || "").toLowerCase().trim());

  const filteredClients = clients.filter((client) => {
    const searchLower = search.toLowerCase();
    return (
      client.customer_name?.toLowerCase().includes(searchLower) ||
      client.customer_id?.toString().toLowerCase().includes(searchLower) ||
      client.web_address?.toLowerCase().includes(searchLower) ||
      client.customer_email?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Layout>
      <div className="client-page">
      <div className="page-header">
        <div className="row align-items-center">
          <div className="col-md-4">
            <div className="pagetitle">
              <h1>Clients</h1>
            </div>
          </div>
          <div className="col-md-8">
            <div className="d-flex justify-content-end gap-2 client-toolbar">
              {/* Search Input – inline background removed, now controlled by CSS */}
              <div className="input-group client-search-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search clients..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
              </div>

              {/* Add Client Button – uses btn-success (primary color) */}
              {canCreateClient && (
                <button
                  className="btn btn-success d-flex align-items-center client-create-btn"
                  onClick={handleAdd}
                >
                  <i className="bi bi-plus"></i>
                    Create Client
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="fixed-height-container">
          <div className="scrollable-card">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    {/* Scrollable table container – height now set in CSS */}
                    <div className="table-responsive-scroll">
                      <table className="table compact-table">
                        <thead>
                          <tr>
                            <th scope="col">S No.</th>
                            <th scope="col">Logo</th>
                            <th scope="col">Client Name</th>
                            <th scope="col">Website</th>
                            <th scope="col">Projects</th>
                            <th scope="col">Onboard Date</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredClients.length === 0 ? (
                            <tr>
                              <td colSpan="7" className="text-center py-4">
                                <i className="bi bi-people"></i>
                                <p className="mt-2">No clients available</p>
                              </td>
                            </tr>
                          ) : (
                            filteredClients.map((client, idx) => {
                              let formattedDate = "-";
                              if (client.customer_joiningDate) {
                                const time = new Date(client.customer_joiningDate);
                                formattedDate = isNaN(time) ? "-" : time.toLocaleDateString();
                              }
                              return (
                                <tr key={client.customer_id} className="client-row">
                                  <td>{idx + 1}</td>
                                  <td>
                                    {client.customer_logo1 ? (
                                      <img
                                        src={client.customer_logo1}
                                        alt={`${client.customer_name} logo`}
                                        className="client-logo-thumb"
                                        onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'flex'; }}
                                      />
                                    ) : null}
                                    <span
                                      className="client-logo-fallback"
                                      style={{ display: client.customer_logo1 ? 'none' : 'flex' }}
                                    >
                                      {(client.customer_name || '?').trim().charAt(0).toUpperCase()}
                                    </span>
                                  </td>
                                  <td className="client-name">{client.customer_name}</td>
                                  <td>
                                    {client.web_address ? (
                                      <a
                                        href={
                                          client.web_address.startsWith("http")
                                            ? client.web_address
                                            : `https://${client.web_address}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {client.web_address}
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    <span className="client-project-count">
                                      {client.no_of_projects ?? 0}
                                    </span>
                                  </td>
                                  <td>{formattedDate}</td>
                                  <td>
                                    <div className="d-flex gap-1 justify-content-center">
                                      <button
                                        className="btn btn-sm btn-info"
                                        onClick={() => handleView(client)}
                                        title="View Client Details"
                                      >
                                        <i className="bi bi-eye"></i>
                                      </button>
                                      {user?.role !== 'employee' && (
                                        <>
                                          <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => handleEdit(client.customer_id)}
                                            title="Edit Client"
                                          >
                                            <i className="bi bi-pencil"></i>
                                          </button>
                                          <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() =>
                                              handleDelete(client.customer_id, client.customer_name)
                                            }
                                            disabled={isDeleting}
                                            title="Delete Client"
                                          >
                                            <i className="bi bi-trash"></i>
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {selectedClient && <ClientDetailsModal client={selectedClient} onClose={handleCloseModal} />}
      </div>
    </Layout>
  );
};

export default Client;